module.exports = __webpack_public_path__ + "static/media/silver.17a55cfc.svg";